import React, { Component } from "react";
import PropTypes from "prop-types";

class StaticTableComponent extends Component {
  render() {
    const { title, headers, data } = this.props;

    return (
      <div
        style={{
          margin: "20px auto",
          maxWidth: "1200px",
          maxHeight: "1000px",
          padding: "10px",
          borderRadius: "2px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
        }}
      >
        {title && (
          <div
            style={{
              color: "#000",
              padding: "16px 24px",
              fontSize: "20px",
              fontWeight: "bold",
              textAlign: "left",
              borderRadius: "8px 8px 0 0",
              marginBottom: "12px",
            }}
          >
            {title}
          </div>
        )}
        <div style={{ overflowX: "auto" }}>
          <div
            style={{
              // overflowY: "auto",
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "8px 12px",
              maxHeight: "600px",
              // overflowY: "auto",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
                position: "sticky",
                top: 0,
              }}
            >
              <thead
                style={{
                  backgroundColor: "#f9fafc",
                  borderRight: "2px solid #e3e6ec",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <tr>
                  {headers.map((header, index) => (
                    <th
                      key={index}
                      style={{
                        borderBottom: "2px solid #e3e6ec",
                        padding: "5px",
                        textAlign: "center",
                        fontSize: "12px",
                        color: "#333",
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        borderRight: "2px solid #e3e6ec",
                        borderLeft: "2px solid #e3e6ec",
                        borderTop: "2px solid #e3e6ec",
                        width: header.width || "auto",
                      }}
                    >
                      {header.label}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {data && data.length > 0 ? (
                  data.map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      style={{
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f9fafe";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }}
                    >
                      {headers.map((header, colIndex) => (
                        <td
                          key={colIndex}
                          style={{
                            borderBottom: "2px solid #f1f4f9",
                            // padding: "6px 10px",
                            fontSize: "12px",
                            color: "#555",
                            borderRight: "2px solid #e3e6ec",
                            borderLeft: "2px solid #e3e6ec",
                            textAlign: header.align || "left",
                            backgroundColor:
                              row.errorFlag == 1 ? "#FC7357" : "transparent",
                          }}
                        >
                          {row[header.key]}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={headers.length}
                      style={{
                        textAlign: "center",
                        padding: "16px",
                        color: "#888",
                        fontSize: "16px",
                      }}
                    >
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

StaticTableComponent.propTypes = {
  title: PropTypes.string,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      align: PropTypes.oneOf(["left", "center", "right"]),
      width: PropTypes.string,
    })
  ).isRequired,
  data: PropTypes.array.isRequired,
  flag: PropTypes.number,
};

export default StaticTableComponent;
